const GA4_ID = 'G-892MCX6JE3';

const script = document.querySelector('script[data-theme-tracking]');
const DEBUG = script?.dataset.debug === 'true';
const THEME_ID = String(window.Shopify?.theme?.id ?? '');

let applied = false;

// gtag gibt es erst nach Zustimmung (Consentmo) - ohne gtag wird nichts gesendet.
function apply(trigger) {
  if (applied || !THEME_ID || typeof window.gtag !== 'function') return;
  applied = true;
  window.gtag('set', 'user_properties', { theme_id: THEME_ID });
  const payload = {
    theme_id: THEME_ID,
    send_to: GA4_ID,
    ...(DEBUG && { debug_mode: true }),
  };
  window.gtag('event', 'theme_exposure', payload);
  if (DEBUG) console.log('[Theme]', trigger, payload);
}

if (!window.Shopify?.designMode) {
  apply('module');
  window.addEventListener('load', () => apply('load'));
  document.addEventListener('visitorConsentCollected', () => apply('consent'));
}

if (DEBUG) {
  console.log('[Theme] Tracking geladen:', THEME_ID || 'keine Theme-ID');
}